export const REPORT_ID = 'slide-24';
export const REPORT_ID_APE = 'slide-24-ape';
export const SLIDE_NUMBER = 24;